<script>
  let { minimumOrderValueEligible } = $props();
</script>

{#if minimumOrderValueEligible}
  <div class="reco_comparison__otto-up-logo">
    <svg class="pl_logo--red" id="pl_logo_otto-up" role="img">
      <use
        href="/assets-static/icons/pl_logo_otto-up.svg#pl_logo_otto-up"
        xlink:href="/assets-static/icons/pl_logo_otto-up.svg#pl_logo_otto-up"></use>
    </svg>
  </div>
{/if}

<style>
  .reco_comparison__otto-up-logo {
    margin-top: 10px;
  }

  .reco_comparison__otto-up-logo svg {
    width: 52px;
    height: 16px;
  }
</style>
